import React from "react";

export default function ResumeSection() {
  return (
    <section id="resume" className="mb-5">
      <h2>Downloadable CV/Resume</h2>
      <a href="https://github.com/white-james/portfolio-site/releases/latest/download/james-white-cv.pdf" className="btn btn-primary" download>
        Download CV/Resume
      </a>
    </section>
  );
}
